import { toggleInList } from '@akin-home/arrays';
import { RECURRENCE_WEEKDAYS } from '@akin-home/recurrence';
import React, { FC } from 'react';
import { View } from 'react-native';
import { DayCheckbox } from './DayCheckbox';
import { styles } from './Weekdays.presets';

interface Props {
  onChangeIDs?: (days: number[]) => void;
  selected?: number[];
}

const DAY_DATA = Object.values(RECURRENCE_WEEKDAYS);

export const Weekdays: FC<Props> = (props) => {
  const { onChangeIDs, selected } = props;

  const handleChange = (id: number) => {
    onChangeIDs?.(toggleInList(selected, id));
  };

  return (
    <View style={styles.horizontalContainer}>
      {DAY_DATA.map((day) => (
        <DayCheckbox
          key={day.id}
          id={day.id}
          label={day.label}
          selected={selected?.includes(day.id)}
          onChange={handleChange}
        />
      ))}
    </View>
  );
};
